import { useCallback, useEffect, useState } from 'react'
// Hooks
import { useWalletContext } from 'providers/WalletProvider'
import { useContract } from 'hooks/useContract/useContract'
// Types
import { UseWpoktMintControllerReturnType, MintData } from './useWpoktMintController.types'

// Constants
import {
    MINT_CONTROLLER_ADDRESS,
    WpoktMintControllerAbi,
} from './useWpoktMintController.constants'

export const useWpoktMintController = (): UseWpoktMintControllerReturnType => {

    const state = useWalletContext()
    const [isLoadingMint, setIsLoadingMint] = useState(true)

    const { callGetter, callSetter } = useContract(
        state,
        WpoktMintControllerAbi,
        MINT_CONTROLLER_ADDRESS,
        "ethereum"
    )

    const mintWpokt = useCallback(
        (mintData: MintData, signatures: string[]) => {

            return callSetter('mintWrappedPocket', [
                mintData,
                signatures
            ])
        },
        [callSetter]
    )

    const initializeParamsMint = useCallback(async () => {
        if (state.currentAccount) {
            try {
                (await callGetter('lastMintLimit', [])) as number
                setIsLoadingMint(false)
            } catch (e) { 
                if ( !(e as any).message || !(e as any).message.includes("underlying network changed") ) console.log(e)
             }
        }
    }, [state.currentAccount, callGetter])

    useEffect(() => {
        initializeParamsMint()
    }, [initializeParamsMint])

    return {
        mintWpokt,
        isLoadingMint,
    }
}